import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

class ProgressBarPopup extends React.Component {

    render() {
        return (<div className="overlayBox">
                   <div className="centerBox">
                <div className="progressBar" style={{left: "100px", top: "180px"}}> 
                            <div className="filler" style={{ width: `${this.props.progressBar*4}px` }}></div>
                        </div>
                    </div>
                </div>)
    }
}

function mapStateToProps(state) {
    return {
        progressBar: state.ui.progressBar,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgressBarPopup)